import { Container, Typography } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const DashboardPage = () => {
  const { user } = useAuth();

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4">Welcome, {user?.displayName || user?.email}</Typography>
      {/* TODO: Implement dashboard */}
    </Container>
  );
};

export default DashboardPage;